if (!customElements.get('product-size-chart')) {
  customElements.define('product-size-chart', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('click', (event) => {
        const button = event.target.closest('button[data-unit]');
        if (!button || !this.contains(button)) return;
        const unit = button.dataset.unit;
        this.querySelectorAll('button[data-unit]').forEach((item) => {
          item.setAttribute('aria-pressed', String(item === button));
        });
        this.querySelector('[data-measurements]').hidden = unit === 'intl';
        const international = this.querySelector('[data-international]');
        if (international) international.hidden = unit !== 'intl';
        if (unit === 'intl') return;
        this.querySelector('[data-unit-label]').textContent = unit;
        this.querySelectorAll('[data-cm]').forEach((cell) => {
          const cm = Number(cell.dataset.cm);
          if (Number.isFinite(cm)) cell.textContent = (unit === 'in' ? cm / 2.54 : cm).toFixed(2);
        });
      });
    }
  });
}
